window.theme = window.theme || {};

window.theme.ProductDeliveryMessage = (function() {
    
    function ProductDeliveryMessage(container){
    this.container = container;

    // delivery message metafield data
    this.data = window.theme.deliveryMessage;
    this.data.deliveryData = {
      "delivery_days": -1,
      "preorder_by":'',
      "preorder_ships":''
    }
    this.data.calculatedVariants = []

    this.deliveryMessageContainer = this.container;
    this.deliveryMessage = document.querySelector('.delivery-message');
    this.preorderMessage = document.querySelector('.preorder-message');

    this.customFormContainer = document.querySelector('#custom-product-form');


    this.initDeliveryMessage();
  }
  return ProductDeliveryMessage;
})();

window.theme.ProductDeliveryMessage.prototype = {

  initDeliveryMessage: function(){
    let self = this;
    
    self.bindEvents();

  },

  bindEvents: function(){
    let self = this;
    
    // listen for variant change
    document.addEventListener('variant:changed', function(event) {
      let variant = event.detail.variant;
      console.log('variant change');
      self.getAllSelections(variant);
    });

    if (this.customFormContainer && this.customFormContainer.classList.contains('loader')) {
      document.addEventListener('custom-product-form:built', function(event) {
        self.buildCalculatedVariants();
      });
    }
    else {
      // build calculatedVariants object 
      self.buildCalculatedVariants();
    }

    document.addEventListener('custom-product-form:built', function(event) {
      console.log('custom form is built');
      // listen for custom form product selections
      let customFormInputs = document.querySelectorAll('.product-menu-variant__input');
      customFormInputs.forEach((input)=>{
        input.addEventListener('click', (event)=>{
          console.log('custom form input change');
          self.getAllSelections();
        })
      });
    });

  },

  buildCalculatedVariants: function(){
    let self = this;

    for (var i = 0; i < this.data.variants.length; i++) {
      let variant = this.data.variants[i];

      // ignore engagement products
      if ( variant.product.tags.indexOf('Brand_By Baby Engagement') > -1  ) {
        continue;
      }

      let deliveryDays = -1;
      let preorderBy = '';
      let preorderShips = '';

      // inventory logic for delivery days
      if (variant.inventory_management != '' && variant.inventory_quantity > 0) {
        // ready-to-ship
        deliveryDays = 1;
        preorderBy = '';
        preorderShips = '';
      }
      else if (variant.inventory_management != '' && variant.inventory_quantity <= 0 && variant.inventory_policy == 'continue'){
        // calculated
        deliveryDays = variant.metafields.delivery_days ? variant.metafields.delivery_days : variant.product.metafields.delivery_days;
        preorderBy = variant.metafields.preorder_by ? variant.metafields.preorder_by : variant.product.metafields.preorder_by;
        preorderShips = variant.metafields.preorder_ships ? variant.metafields.preorder_ships : variant.product.metafields.preorder_ships;
      }

      let calculatedVariant = {
        "id": variant.id,
        "title": variant.title,
        "inventory_management": variant.inventory_management,
        "inventory_policy": variant.inventory_policy,
        "inventory_quantity": variant.inventory_quantity,
        "delivery_days": deliveryDays,
        "preorder_by": preorderBy,
        "preorder_ships": preorderShips

      }
      this.data.calculatedVariants.push(calculatedVariant)
    }

  },

  getMatchingVariantData: function(variant){
    let self = this;
    let selectedVariantId = variant

    for (let i = 0; i < this.data.calculatedVariants.length; i++) {
    	let variant = this.data.calculatedVariants[i];
    	if (variant.id == selectedVariantId) {
    		return variant;
    	}
    }

  },

  getAllSelections: function(variant){
    let self = this;
    self.resetDeliveryData();

    // get all selected variants
    let masterVariantSelectorSelects = document.querySelectorAll('select.master-variant-selector'); // multi variants
    let masterVariantSelectorInput = document.querySelector('input.master-variant-selector'); // only default variant

    if (masterVariantSelectorSelects) {
      // multi variants
      if (variant) {
        let matchedVariant = self.getMatchingVariantData(variant.id);
        if (matchedVariant) { self.calculateDeliveryData(matchedVariant); }
      }
      else {
        for (var i = 0; i < masterVariantSelectorSelects.length; i++) {
          let select = masterVariantSelectorSelects[i];
          let selectedOption = select.options[select.selectedIndex];
          let matchedVariant = self.getMatchingVariantData(selectedOption.value);
          if (matchedVariant) { self.calculateDeliveryData(matchedVariant); }
        }
      }
    } 
    else {
      // only default variants
      let matchedVariant = self.getMatchingVariantData(masterVariantSelectorInput.value);
      if (matchedVariant) { self.calculateDeliveryData(matchedVariant); }
    }

    // get all selected inputs from custom form
    if (this.customFormContainer) {
      // get and calculate inputs
      let checkedInputs = document.querySelectorAll('input:checked');
      for (var i = 0; i < checkedInputs.length; i++) {
        let checkedInput = checkedInputs[i]
        if (checkedInput.hasAttribute('data-variant-price')) {
          if (checkedInput.dataset.validConditionalChild == "false") {
            // do nothing if data-valid-conditional-child is false
          }
          else {
            let matchedVariant = self.getMatchingVariantData(checkedInput.dataset.variantId);
            if (matchedVariant) { self.calculateDeliveryData(matchedVariant); }
          }
        }
      }
    }

  },

  resetDeliveryData: function(){
    let self = this;
    this.data.deliveryData = {
      "delivery_days": -1,
      "preorder_by":'',
      "preorder_ships":''
    }
  },

  calculateDeliveryData: function(variant){
    let self = this;
    console.log(variant);

    //check delivery days
    if (variant.delivery_days > this.data.deliveryData.delivery_days) {
      this.data.deliveryData.delivery_days = variant.delivery_days
    }

    //check presale order by
    if (variant.preorder_by != '') {

      existingOrderBy = this.data.deliveryData.preorder_by
      orderByDate = new Date(variant.preorder_by);
      shipsByDate = new Date(variant.preorder_ships);

      if (orderByDate > existingOrderBy) {
        this.data.deliveryData.preorder_by = orderByDate
        this.data.deliveryData.preorder_ships = shipsByDate
      }

    }

    console.log(this.data.deliveryData);
    self.calculateMessageType();
    
  },

  calculateMessageType: function(){
    let self = this;

    let deliveryDays = this.data.deliveryData.delivery_days;
    let preorderBy = this.data.deliveryData.preorder_by;
    let preorderShips = this.data.deliveryData.preorder_ships;

    if (preorderBy != '') {
      let messageType = 'Pre-order';
    	let messageHtml = self.createPreOrderMessage(preorderBy, preorderShips);
      self.setMessage(messageType,messageHtml);
    }
    else if (deliveryDays && deliveryDays >= 0 && preorderBy == '') {
      let messageType = 'Delivery';
    	let messageHtml = self.createDeliveryMessage(deliveryDays);
      self.setMessage(messageType,messageHtml);
    }
    else {
    	self.clearMessage();
    }

  },

  createPreOrderMessage: function(orderByDate, shipsByDate){
    let self = this;

    orderByDate = new Date(orderByDate);
    shipsByDate = new Date(shipsByDate);
    today = new Date();

    orderByDateString = orderByDate.toLocaleString('default', {
												  // weekday: 'short', // "Sat"
												  day: 'numeric', // "1"
												  month: 'short', // "Jun"
												  year: 'numeric' // "2019"
												});

    shipsByDateString = shipsByDate.toLocaleString('default', {
												  // weekday: 'short', // "Sat"
												  day: 'numeric', // "1"
												  month: 'short', // "Jun"
												  year: 'numeric' // "2019"
												});

    todayPlusTwoMonths = new Date(String(today));
    todayPlusTwoMonths = new Date(todayPlusTwoMonths.setMonth(todayPlusTwoMonths.getMonth() + 2));
   
   	todayPlusTwoMonthsString = todayPlusTwoMonths.toLocaleString('default', {
												  month: 'long' // "Jun"
												});

    if (today < orderByDate) {
    	return messageHtml = `<p>Order by <strong>${orderByDateString}</strong></p>
				<p>Ship the week of the <strong>${shipsByDateString}</strong></p>`
    }
    else {
    	return messageHtml = `<p><strong>Shipping end of ${todayPlusTwoMonthsString}</strong></p>`
    }

  },

  createDeliveryMessage: function(days){
    let self = this;

    let deliveryMessageText = ''

    if (days == 0) {
    	deliveryMessageText = window.languages.deliveryMessage_in_stock
    }
    else if (days >= 1 && days <= 2) {
      deliveryMessageText = window.languages.deliveryMessage_1_2
    }
    else if (days >= 3 && days <= 5) {
    	deliveryMessageText = window.languages.deliveryMessage_3_5
    }
    else if (days >= 6 && days <= 7) {
    	deliveryMessageText = window.languages.deliveryMessage_6_7
    }
    else if (days >= 8 && days <= 10) {
    	deliveryMessageText = window.languages.deliveryMessage_8_10
    }
    else if (days >= 11 && days <= 14) {
    	deliveryMessageText = window.languages.deliveryMessage_11_14
    }
    else if (days >= 15 && days <= 20) {
    	deliveryMessageText = window.languages.deliveryMessage_15_20
    }
    else if (days >= 21 && days <= 25) {
    	deliveryMessageText = window.languages.deliveryMessage_21_25
    }
    else if (days >= 26 && days <= 30) {
    	deliveryMessageText = window.languages.deliveryMessage_26_30
    }
    else if (days >= 31 && days <= 35) {
    	deliveryMessageText = window.languages.deliveryMessage_31_35
    }
    else if (days >= 36 && days <= 40) {
    	deliveryMessageText = window.languages.deliveryMessage_36_40
    }
    else if (days >= 41 && days <= 45) {
    	deliveryMessageText = window.languages.deliveryMessage_41_45
    }
    else if (days >= 46 && days <= 50) {
    	deliveryMessageText = window.languages.deliveryMessage_46_50
    }
    else if (days >= 51 && days <= 55) {
    	deliveryMessageText = window.languages.deliveryMessage_51_55
    }
    else if (days >= 56 && days <= 60) {
    	deliveryMessageText = window.languages.deliveryMessage_56_60
    }

    if (deliveryMessageText != '') {
      return messageHtml = `<p><strong>${deliveryMessageText}</strong></p>`
    }
    else {
      return messageHtml = ''
    }

  },

  setMessage: function(messageType,messageHtml){
    let self = this;
    self.clearMessage();

    if (messageType == 'Pre-order') {
      self.updateAddToCartButton('Pre-order');
      this.preorderMessage.innerHTML = messageHtml
    }
    else {
      self.updateAddToCartButton('Add to cart');
      this.deliveryMessage.innerHTML = messageHtml;
    };
  },

  clearMessage: function(){
    let self = this;

  	self.updateAddToCartButton('Add to cart');
    this.deliveryMessage.innerHTML = ``
    this.preorderMessage.innerHTML = ``

  },

  updateAddToCartButton: function(text){
  	let self = this
  	setTimeout(() => {
  		let addToCartButtonSpan = document.querySelector('.ProductForm__BuyButtons button[data-action="add-to-cart"] span');
  			if (addToCartButtonSpan) {
  				addToCartButtonSpan.innerHTML = text
  			}
  	},2);

  },

};

document.addEventListener("DOMContentLoaded", function(event) {
  // check that container exists
  const deliveryMessageContainer = document.querySelector('.delivery-message-container');
  if (deliveryMessageContainer){
    // if it exists, call the thing
    new window.theme.ProductDeliveryMessage(deliveryMessageContainer);
  }
});